import { Location } from '@cobliteam/common-types';
import { lazy } from 'react';
import PathAssociationRouter from '../pages';

const PathAssociationPage = lazy(() => import('../pages/PathAssociationPage'));
const VehiclePathsPage = lazy(() => import('../pages/VehiclePathsPage'));

const routes = [
  {
    path: Location.PATH_ASSOCIATION,
    component: PathAssociationRouter,
    featureFlag: 'enableDriverAssociationPast',
    routes: [
      {
        path: Location.PATH_ASSOCIATION_VEHICLE,
        component: VehiclePathsPage,
        exact: true,
      },
      {
        path: Location.PATH_ASSOCIATION,
        component: PathAssociationPage,
        exact: true,
      },
    ],
  },
];

export default routes;
